module.exports = __webpack_public_path__ + "assets/img/37_1559.0e63cee3.jpg";